import { useState, useEffect } from 'react';

const mobileMaxWidth = 640;
const smallDesktopMaxWidth = 1024;
const mediumDesktopMaxWidth = 1366;

export const ResponsiveMode = {
  Mobile: 'mobile',
  SmallDesktop: 'small-desktop',
  MediumDesktop: 'medium-desktop',
  LargeDesktop: 'large-desktop',
};

export const useResponsiveMode = (element) => {
  const [isMobile, setIsMobile] = useState(false);
  const [responsiveMode, setResponsiveMode] = useState(ResponsiveMode.LargeDesktop);

  useEffect(() => {
    const getWidth = () => element.offsetWidth;

    const setResponsiveValues = () => {
      const currentWidth = getWidth();
      if (currentWidth < mobileMaxWidth) {
        setIsMobile(true);
        setResponsiveMode(ResponsiveMode.Mobile);

        return;
      }

      if (currentWidth < smallDesktopMaxWidth) {
        setIsMobile(false);
        setResponsiveMode(ResponsiveMode.SmallDesktop);

        return;
      }

      if (currentWidth < mediumDesktopMaxWidth) {
        setIsMobile(false);
        setResponsiveMode(ResponsiveMode.MediumDesktop);

        return;
      }

      setIsMobile(false);
      setResponsiveMode(ResponsiveMode.LargeDesktop);
    };

    const handleResize = () => {
      if (element) {
        setResponsiveValues();
      }
    };

    if (element) {
      setResponsiveValues();
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [element]);

  return { isMobile, responsiveMode };
};
